export const DATA_ENTITY_TYPE = 'data-entity-type';
export const DATA_CONVERSATION_FRIENDLY_ID = 'data-conversation-friendly-id';
export const DATA_PARTNER_PREFIX = 'data-partner-prefix';
